// Following a link from a note: open the note, sketch, diagram or timeline it points at.
import { openDiagram, openNote, openSketch, openTimeline } from '../state/dock';
import { createNote } from '../state/notes';
import { revealEntity, select } from '../state/workspace';
import type { LinkTarget } from '@modelviewer/core';

export function openTarget(t: LinkTarget): void {
  switch (t.kind) {
    case 'note':
      openNote(t.id);
      return;
    case 'sketch':
      openSketch(t.id);
      return;
    case 'migration':
      openTimeline(t.setKey, t.id);
      return;
    case 'context':
      openDiagram({ setKey: t.setKey, migrationId: null });
      return;
    case 'entity':
      if (t.ref.sketchId) openSketch(t.ref.sketchId);
      else openDiagram(t.ref);
      // After the tab is there; the diagram centers on the entity once it has laid out.
      window.setTimeout(() => {
        revealEntity(t.ref, t.entity);
        if (t.property) select(t.ref, { kind: 'property', entity: t.entity, property: t.property });
      }, 0);
      return;
  }
}

/** A link to nothing: create the note it names, as Obsidian does. */
export async function createLinkedNote(target: string): Promise<void> {
  const title = target.replace(/^note:/i, '').trim();
  const note = await createNote(title, '');
  if (note) openNote(note.id);
}
